<template lang="pug">
.container
  .header
    el-button-group.float-right(v-model='scope')
      el-button(:type='scope === "getLoggedUsersByNetwork" ? "success" : "default"', size='mini', @click='scope = "getLoggedUsersByNetwork"')
        span {{ $t('Network') }}
      el-button(:type='scope === "getLoggedUsersByClient" ? "success" : "default"', size='mini', @click='scope = "getLoggedUsersByClient"')
        span {{ $t('Client') }}
      el-button(:type='scope === "getLoggedUsersAll" ? "success" : "default"', size='mini', @click='scope = "getLoggedUsersAll"')
        span {{ $t('Wave2') }}
    h4 {{ $t('Logged in users') }}
  .table-header-row
    .cell {{ $t('Nick') }}
      el-input.input(id="UserList-nickSearchInput" v-model='search.nick', size='mini', type='text', clearable)
    .cell {{ $t('Email') }}
      el-input.input(id="UserList-emailSearchInput" v-model='search.email', size='mini', type='text', clearable)
    .cell {{ $t('Network') }}
      el-input.input(id="UserList-networkSearchInput" v-model='search.network', size='mini', type='text', clearable)
  hr.header
  .user-row(v-for="user of usersFiltered", :key="user.email")
    .cell {{ user.nick }}
    .cell {{ user.email }}
    .cell {{ user.Network.name }}
</template>

<script>
import Vue from 'vue'

export default {
  async created () {
    await this.loadData()
  },
  watch: {
    scope: async function (newVal, oldVal) {
      await this.loadData()
    }
  },
  data () {
    return {
      users: [],
      scope: 'getLoggedUsersByNetwork',
      search: {
        nick: '',
        email: '',
        network: ''
      }
    }
  },
  methods: {
    async loadData () {
      this.users = (await Vue.axios.post(`user/${this.scope}`, {})).data
    }
  },
  computed: {
    usersFiltered () {
      let result = this.users
      if (this.search.nick.length > 0) result = result.filter(u => u.nick.toLowerCase().indexOf(this.search.nick.toLowerCase()) > -1)
      if (this.search.email.length > 0) result = result.filter(u => u.email.toLowerCase().indexOf(this.search.email.toLowerCase()) > -1)
      if (this.search.network.length > 0) result = result.filter(u => u.Network.name.toLowerCase().indexOf(this.search.network.toLowerCase()) > -1)
      return result
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/LayoutComponents/UsersLoggedIn.vue